export { default } from "./AvatarSkeleton";
